import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000';
const GOOGLE_AUTH = `https://turival.techbrain.cl/auth/google`;

const ROLES = [
  { id: 'capitan', label: '⚙️ Soy capitán',  color: '#FF6B1A', desc: 'Gestiona tu equipo y desafía rivales' },
  { id: 'arbitro', label: '🟡 Soy árbitro',   color: '#F59E0B', desc: 'Arbitra partidos y genera ingresos'  },
  { id: 'recinto', label: '🏟️ Soy recinto',   color: '#1A6BFF', desc: 'Administra tus canchas y reservas'  },
];

const DEPORTES = [
  { id: 'futbol', label: 'Fútbol', icono: '⚽' },
  { id: 'padel',  label: 'Pádel',  icono: '🎾' },
  { id: 'tenis',  label: 'Tenis',  icono: '🎾' },
];

function redirigir(rol, navigate) {
  if (rol === 'arbitro' || rol === 'tercer_tiempo') navigate('/app/panel-proveedor');
  else if (rol === 'recinto') navigate('/app/panel-recinto');
  else navigate('/app/dashboard');
}

export default function Login() {
  const navigate         = useNavigate();
  const { login, error } = useAuth();

  const [email,        setEmail]        = useState('');
  const [password,     setPassword]     = useState('');
  const [loading,      setLoading]      = useState(false);
  const [errLocal,     setErrLocal]     = useState('');
  const [rolGoogle,    setRolGoogle]    = useState(null);
  const [rolSeleccionado, setRolSeleccionado] = useState(null);
  const [deporteSeleccionado, setDeporteSeleccionado] = useState('futbol');

  // Detectar si viene de invitación externa
  const invExternaToken  = localStorage.getItem('turival_invitacion_externa_token');
  const invExternaDeporte = localStorage.getItem('turival_deporte_login');
  const esInvitadoExterno = !!invExternaToken;

  const handleLogin = async () => {
    if (!email || !password) { setErrLocal('Ingresa tu email y contraseña'); return; }
    setLoading(true); setErrLocal('');
    const result = await login(email, password);
    setLoading(false);
    if (result.ok) redirigir(result.rol, navigate);
    else setErrLocal(error || 'Credenciales inválidas');
  };

  const handleGoogleDirecto = () => {
    // Para invitados externos — directo sin selección de rol ni deporte
    const params = new URLSearchParams({
      rol:    'capitan',
      deporte: invExternaDeporte || 'padel',
    });
    window.location.href = `${GOOGLE_AUTH}?${params.toString()}`;
  };

  const handleGoogleRol = () => {
    const params = new URLSearchParams({ rol: rolSeleccionado });
    if (rolSeleccionado === 'capitan') {
      params.append('deporte', deporteSeleccionado);
      localStorage.setItem('turival_deporte_login', deporteSeleccionado);
    }
    window.location.href = `${GOOGLE_AUTH}?${params.toString()}`;
  };

  // Pantalla simplificada para invitados externos
  if (esInvitadoExterno) {
    const deporteLabel = invExternaDeporte === 'tenis' ? 'Tenis' : invExternaDeporte === 'futbol' ? 'Fútbol' : 'Pádel';
    const deporteIcono = invExternaDeporte === 'futbol' ? '⚽' : '🎾';
    return (
      <div style={styles.pagina}>
        <div style={styles.card}>
          <div style={styles.logo}>Tu<span style={styles.naranja}>Rival</span></div>
          <div style={{ fontSize: 40, textAlign: 'center', marginBottom: 8 }}>{deporteIcono}</div>
          <div style={{ ...styles.titulo, textAlign: 'center', marginBottom: 8 }}>
            ¡Un paso más!
          </div>
          <div style={{ ...styles.sub, textAlign: 'center', marginBottom: 24 }}>
            Regístrate gratis con Google para unirte a TuRival y jugar {deporteLabel}.
          </div>
          <button style={styles.btnGoogle} onClick={handleGoogleDirecto}>
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" style={{ width: 20, height: 20 }} />
            Registrarme con Google
          </button>
          <div style={{ ...styles.sub, textAlign: 'center', marginTop: 16, fontSize: 11 }}>
            ⚡ ¡Conectá · Desafiá · Jugá!
          </div>
        </div>
      </div>
    );
  }

  // Pantalla selección de rol para Google
  if (rolGoogle === 'select') {
    return (
      <div style={styles.pagina}>
        <div style={styles.card}>
          <div style={styles.logo}>Tu<span style={styles.naranja}>Rival</span></div>
          <div style={styles.titulo}>¿Cómo quieres entrar?</div>
          <div style={styles.sub}>Selecciona tu rol para continuar con Google</div>

          {/* Roles */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
            {ROLES.map(r => (
              <button
                key={r.id}
                style={{
                  ...styles.btnRolGoogle,
                  borderColor: rolSeleccionado === r.id ? r.color : 'rgba(255,255,255,0.12)',
                  background:  rolSeleccionado === r.id ? r.color + '22' : 'rgba(255,255,255,0.05)',
                }}
                onClick={() => setRolSeleccionado(r.id)}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="G" style={{ width: 18 }} />
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontWeight: 700, color: 'white', fontSize: 14 }}>{r.label}</div>
                    <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>{r.desc}</div>
                  </div>
                </div>
              </button>
            ))}
          </div>

          {/* Selector deporte — solo para capitán */}
          {rolSeleccionado === 'capitan' && (
            <div style={styles.deporteWrap}>
              <div style={styles.deporteLabel}>¿Qué deporte?</div>
              <div style={styles.deporteGrid}>
                {DEPORTES.map(d => (
                  <button
                    key={d.id}
                    onClick={() => setDeporteSeleccionado(d.id)}
                    style={{
                      ...styles.deporteBtn,
                      background:  deporteSeleccionado === d.id ? '#FF6B1A' : 'rgba(255,255,255,0.05)',
                      borderColor: deporteSeleccionado === d.id ? '#FF6B1A' : 'rgba(255,255,255,0.12)',
                      color:       deporteSeleccionado === d.id ? 'white'   : 'rgba(255,255,255,0.5)',
                    }}
                  >
                    {d.icono} {d.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Botón continuar */}
          {rolSeleccionado && (
            <button
              style={{ ...styles.btnContinuar, marginBottom: 10 }}
              onClick={handleGoogleRol}
            >
              <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="G" style={{ width: 18 }} />
              Continuar con Google
            </button>
          )}

          <button style={styles.btnVolver} onClick={() => { setRolGoogle(null); setRolSeleccionado(null); }}>
            ← Volver
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.pagina}>
      <div style={styles.card}>
        <div style={styles.logo}>Tu<span style={styles.naranja}>Rival</span></div>
        <div style={styles.sub}>Accede a tu cuenta para desafiar equipos</div>

        <button style={styles.btnGoogle} onClick={() => setRolGoogle('select')}>
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" style={{ width: 20, height: 20 }} />
          Continuar con Google
        </button>

        <div style={styles.divisor}>
          <div style={styles.divisorLinea} />
          <span style={styles.divisorTexto}>o</span>
          <div style={styles.divisorLinea} />
        </div>

        <div style={styles.campo}>
          <input type="email" value={email}
            onChange={e => { setEmail(e.target.value); setErrLocal(''); }}
            placeholder="Email" style={styles.input}
            onKeyDown={e => e.key === 'Enter' && handleLogin()} />
        </div>
        <div style={styles.campo}>
          <input type="password" value={password}
            onChange={e => { setPassword(e.target.value); setErrLocal(''); }}
            placeholder="Contraseña" style={styles.input}
            onKeyDown={e => e.key === 'Enter' && handleLogin()} />
        </div>

        {errLocal && <div style={styles.error}>{errLocal}</div>}

        <button
          style={{ ...styles.btnLogin, opacity: loading ? 0.7 : 1 }}
          onClick={handleLogin} disabled={loading}
        >
          {loading ? 'Entrando...' : 'Entrar →'}
        </button>

        <div style={styles.registro}>
          ¿No tienes cuenta?{' '}
          <span style={styles.registroLink} onClick={() => navigate('/registro')}>
            Crear Cuenta →
          </span>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pagina: {
    minHeight: '100vh', background: '#0D1117',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
  },
  card: {
    background: '#161C26', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 20, padding: 36, width: '100%', maxWidth: 420,
  },
  logo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 36, fontWeight: 800, color: 'white',
    textAlign: 'center', marginBottom: 8,
  },
  naranja: { color: '#FF6B1A' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 22, fontWeight: 800, color: 'white',
    textAlign: 'center', marginBottom: 6,
  },
  sub: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)',
    textAlign: 'center', marginBottom: 24, fontFamily: "'Barlow', sans-serif",
  },
  btnGoogle: {
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
    width: '100%', padding: '13px', background: 'white', border: 'none',
    borderRadius: 12, cursor: 'pointer', fontFamily: "'Barlow', sans-serif",
    fontSize: 15, fontWeight: 600, color: '#141922', marginBottom: 20,
    boxSizing: 'border-box',
  },
  btnRolGoogle: {
    width: '100%', padding: '14px 16px',
    border: '1.5px solid',
    borderRadius: 12, cursor: 'pointer', boxSizing: 'border-box',
    transition: 'all 0.12s',
  },
  deporteWrap: {
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 12, padding: '14px 16px', marginBottom: 14,
  },
  deporteLabel: {
    fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.35)',
    textTransform: 'uppercase', letterSpacing: '0.06em',
    fontFamily: "'Barlow', sans-serif", marginBottom: 10, textAlign: 'center',
  },
  deporteGrid: {
    display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8,
  },
  deporteBtn: {
    padding: '10px 6px', border: '1.5px solid',
    borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 700,
    fontFamily: "'Barlow Condensed', sans-serif",
    transition: 'all 0.12s',
  },
  btnContinuar: {
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
    width: '100%', padding: '13px', background: '#FF6B1A', border: 'none',
    borderRadius: 12, cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 800, color: 'white', boxSizing: 'border-box',
  },
  btnVolver: {
    width: '100%', padding: '11px', background: 'transparent',
    border: '1px solid rgba(255,255,255,0.15)', borderRadius: 10,
    color: 'rgba(255,255,255,0.4)', cursor: 'pointer',
    fontFamily: "'Barlow', sans-serif", fontSize: 13,
  },
  divisor: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 },
  divisorLinea: { flex: 1, height: 1, background: 'rgba(255,255,255,0.1)' },
  divisorTexto: { fontSize: 12, color: 'rgba(255,255,255,0.3)', fontFamily: "'Barlow', sans-serif" },
  campo: { marginBottom: 12 },
  input: {
    width: '100%', padding: '13px 16px',
    background: 'rgba(255,255,255,0.06)',
    border: '1.5px solid rgba(255,255,255,0.1)',
    borderRadius: 12, fontSize: 14, color: 'white',
    fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box',
  },
  error: {
    color: '#EF4444', fontSize: 12, fontFamily: "'Barlow', sans-serif",
    marginBottom: 12, textAlign: 'center',
  },
  btnLogin: {
    width: '100%', padding: '14px', background: '#FF6B1A', border: 'none',
    borderRadius: 12, cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800, color: 'white', marginBottom: 16,
  },
  registro: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)',
    textAlign: 'center', fontFamily: "'Barlow', sans-serif",
  },
  registroLink: { color: '#1A6BFF', cursor: 'pointer', fontWeight: 600 },
};
